module.exports = __webpack_public_path__ + "img/medium.9c354419.png";